import React from 'react'
import { useParams } from 'react-router-dom'
import TimeOverview from '@/components/ProjectCentral/TimeOverview'
import ProjectLayout from '@/components/ProjectCentral/ProjectLayout'

const ProjectTime = () => {
  const { id } = useParams()

  return (
    <ProjectLayout>
      <TimeOverview projectId={id} />
    </ProjectLayout>
  )
}

export default ProjectTime
